"use client";
import React from "react";
import HeadingSize from "../ui/HeadingSize";
import { AnimatedOptimizedImageDebounced as AnimatedOptimizedImage } from "@/components/shared/AnimatedOptimizedImage";
import ResponsivePicture from "../ui/ResponsivePicture";

const QualityBarSection = () => {
  return (
    <section
      className="relative bg-white py-6 sm:py-16 md:py-24"
      aria-labelledby="quality-bar-heading"
    >
      <div
        className="h-[160px] absolute -top-[330px] right-0 lg:hidden"
        aria-hidden="true"
      >
        <ResponsivePicture
          baseSrc="/images/home/Ingredient/2nd"
          alt="Decorative dots graphic"
          width={160}
          height={160}
          className="object-contain w-[120px] h-[120px]"
        />
      </div>

      <div className="container px-0 m-0 max-w-[100%]">
        <div
          id="quality-bar-heading"
          className="px-8 text-center mb-8 sm:mb-20 max-w-6xl mx-auto"
        >
          <HeadingSize text="We set the bar for quality — and keep raising it" />
        </div>

        <div
          className="h-[160px] absolute -top-[80px] -left-3 md:top-[150px] lg:top-[150px] z-20"
          aria-hidden="true"
        >
          <ResponsivePicture
            baseSrc="/images/home/Ingredient/1st"
            alt="Decorative person graphic"
            width={160}
            height={300}
            className="object-contain w-[80px] h-[100px] md:h-[300px] md:w-[150px]"
          />
        </div>

        <div className="mx-auto mb-8 sm:mb-16">
          <div className="grid grid-cols-2 md:grid-cols-2 relative">
            {/* Top Left */}
            <div
              className="flex flex-col items-center text-center relative z-10 py-6 px-12"
              role="group"
              aria-label="Obsessively curated product"
            >
              <div className="text-2xl md:text-5xl lg:text-6xl font-bold text-[#ac000c] mb-2 md:mb-4">
                1
              </div>
              <p className="text-md text-[#000000] font-['Ainslie_Sans'] font-medium md:text-xl lg:text-[32px] lg:leading-[36px]">
                Obsessively
                <br />
                curated product
              </p>
            </div>

            {/* Top Right */}
            <div
              className="flex flex-col items-center text-center relative z-10 py-6 px-12 border-t border-b border-l border-[#ff0000] rounded-tl-[80px] md:rounded-tl-[220px]"
              role="group"
              aria-label="30+ years of research legacy"
            >
              <div className="text-2xl md:text-5xl lg:text-6xl font-bold text-[#ac000c] mb-2 md:mb-4">
                30+
              </div>
              <p className="text-md text-[#000000] font-['Ainslie_Sans'] font-medium md:text-xl lg:text-[32px] lg:leading-[36px]">
                Years of
                <br />
                research legacy
              </p>
            </div>

            {/* Bottom Left */}
            <div
              className="flex flex-col items-center text-center relative z-10 py-6 px-12 border-t border-b border-r border-[#ff0000] rounded-br-[80px] md:rounded-br-[220px]"
              role="group"
              aria-label="200+ granted patents"
            >
              <div className="text-2xl md:text-5xl lg:text-6xl font-bold text-[#ac000c] mb-1">
                200+
              </div>
              <p className="text-md text-[#000000] font-['Ainslie_Sans'] font-medium md:text-xl lg:text-[32px]">
                Granted patents
              </p>
            </div>

            {/* Bottom Right */}
            <div
              className="flex flex-col items-center text-center relative z-10 py-6 px-12"
              role="group"
              aria-label="6 exciting Indian flavours"
            >
              <div className="text-2xl md:text-5xl lg:text-6xl font-bold text-[#ac000c] mb-1">
                6
              </div>
              <p className="text-md text-[#000000] font-['Ainslie_Sans'] font-medium md:text-xl lg:text-[32px] lg:leading-[36px]">
                Exciting
                <br />
                Indian flavours
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default QualityBarSection;
